/**
 * Enum for the different contract status types
 */
export enum ContractStatusType {
  Created = 'Created',
  Modified = 'Modified',
  Approved = 'Approved',
  Archived = 'Archived',
}
